"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const MilestoneAwardManifest_1 = require("@/client/MilestoneAwardManifest");
exports.default = vue_1.default.extend({
    name: 'Milestone',
    props: {
        milestone: {
            type: Object,
        },
        showScores: {
            type: Boolean,
            default: true,
        },
        showDescription: {
            type: Boolean,
        },
    },
    computed: {
        nameCss() {
            return 'ma-name ma-name--' + this.milestone.name.replace(/ /g, '-').replace(/\./g, '').toLowerCase();
        },
        description() {
            return (0, MilestoneAwardManifest_1.getMilestoneAwardDescription)(this.milestone.name);
        },
    },
});
